import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

import { BaseService } from './base-service';
import { ListWorkPackageCategories$Params } from '@api/backend-connector/fn/work-package-categories/list-work-package-categories';
import {
  CreateWorkPackageCategoryRequest,
  UpdateWorkPackageCategoryRequest,
  WorkPackageCategoryDto,
  WorkPackageCategoryDtoPage,
} from '@api/backend-connector/models';
import { WorkPackageCategoriesApi } from '@api/backend-connector/services';

const toasts = {
  createSuccessSummary: 'i18n.WorkPackageCategoryToast.createSuccessSummary',
  createSuccessDetail: 'i18n.WorkPackageCategoryToast.createSuccessDetail',
  createFailSummary: 'i18n.WorkPackageCategoryToast.createFailSummary',
  createFailDetail: 'i18n.WorkPackageCategoryToast.createFailDetail',

  updateSuccessSummary: 'i18n.Toast.updateSuccessSummary',
  updateSuccessDetail: 'i18n.Toast.updateSuccessDetail',
  updateFailSummary: 'i18n.Toast.updateFailSummary',
  updateFailDetail: 'i18n.Toast.updateFailDetail',

  deleteSuccessSummary: 'i18n.WorkPackageCategoryToast.deleteSuccessSummary',
  deleteSuccessDetail: 'i18n.WorkPackageCategoryToast.deleteSuccessDetail',
  deleteFailSummary: 'i18n.WorkPackageCategoryToast.deleteFailSummary',
  deleteFailDetail: 'i18n.WorkPackageCategoryToast.deleteFailDetail',
};

@Injectable({
  providedIn: 'root',
})
export class WorkPackageCategoriesService extends BaseService {
  private readonly workPackageCategoriesApi = inject(WorkPackageCategoriesApi);
  readonly toasts = toasts;

  readonly refresh$ = new BehaviorSubject<void>(undefined);

  listWorkPackageCategories(params: ListWorkPackageCategories$Params): Observable<WorkPackageCategoryDtoPage> {
    return this.workPackageCategoriesApi.listWorkPackageCategories(params);
  }

  getWorkPackageCategory(params: { id: string }): Observable<WorkPackageCategoryDto> {
    return this.workPackageCategoriesApi.getWorkPackageCategory({
      ...params,
    });
  }

  createWorkPackageCategory(request: CreateWorkPackageCategoryRequest) {
    return this.workPackageCategoriesApi.createWorkPackageCategory({ body: request });
  }

  updateCategory(id: string, body: UpdateWorkPackageCategoryRequest) {
    return this.workPackageCategoriesApi.updateWorkPackageCategory({ id, body });
  }

  deleteWorkPackageCategory(params: { id: string }) {
    return this.workPackageCategoriesApi.deleteWorkPackageCategory(params);
  }
}
